var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhsVerticalLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 90,
    viewBox: "0 0 1 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -2.18557e-8,
    x2: 0.500004,
    y2: 90,
    stroke: "#E3E3E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhsVerticalLine);
export default __webpack_public_path__ + "static/media/WHSVerticalLine.262b6dc9904e99cdc26705d9f79c1064.svg";
export { ForwardRef as ReactComponent };